import React, { memo, ReactElement, useEffect, useState } from 'react'
import { Spin } from 'antd'
import { Translate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { IAppState } from 'core/store/store'
import { IAuditEventsDetailsState, TAuditEventsDetailsProps } from './AuditLogsDetail.types'
import { fetchAuditEvent } from '../audit-logs/AuditLogs.actions'
import { getEvent } from './AuditEventsDetail.selectors'
import { emptyAuditEvent } from './AuditEventsDetail.constants'
import { formatDateWithTimestampAndTimezone, formatTextFirstLetterCapitalize} from 'shared/helpers/utils'
import { Spinner } from '@digicert/dcone-common-ui'
import styles from './AuditEventsDetail.module.scss'
import { IAuditLogsEvent } from '../audit-logs/AuditLogs.types'

const dcOneSpinner = <Spinner/>

const AuditEventsDetail = ({ event, fetchAuditEvent, match, profile }: TAuditEventsDetailsProps): ReactElement => {
  const [ loading, setLoading ] = useState(false)
  const [ eventRender, setEvent ] = useState(event || emptyAuditEvent)
  const id = match.params.id
  useEffect(() => {
    if (event) {
      return
    }
    setLoading(true)
    fetchAuditEvent(id)
      .then((eventRes: IAuditLogsEvent) => {
        setEvent(eventRes)
      })
      .catch((error) => {
        console.error('Failed to fetch audit event:', error)
      })
      .finally(() => setLoading(false))
  }, [fetchAuditEvent, id])
  return eventRender ? (
    <Spin tip={'Loading...'} spinning={loading} indicator={dcOneSpinner}>
      <div className={styles.auditEvents}>
        <header>
          <h1>
            <Translate id='reporting.auditEvents.titleDetails' />
          </h1>
        </header>

        <p><b><Translate id='reporting.auditEvents.eventId' />:</b> {eventRender.id}</p>
        <p>
          <b><Translate id='common.action' />:</b>&nbsp;
          {formatTextFirstLetterCapitalize(eventRender.action)}
        </p>
        <p><b><Translate id='common.date' />:</b> { formatDateWithTimestampAndTimezone(eventRender.timestamp) }</p>
        <p><b><Translate id='reporting.auditEvents.resourceType.title' />:</b> <Translate id= {`reporting.auditEvents.resourceType.${eventRender.resource_type}`}/></p>
        <p><b><Translate id='reporting.auditEvents.resourceId' />:</b> {eventRender.resource_id}</p>
        <p><b><Translate id='common.description' />:</b> {eventRender.description}</p>
        <p><b><Translate id='common.form.status' />:</b> {formatTextFirstLetterCapitalize(eventRender.status)}</p>
        <p><b><Translate id='common.form.clientIp' />:</b> {eventRender.client_ip}</p>
      </div>
    </Spin>
  ) : <></>
}

AuditEventsDetail.displayName = 'AuditEventsDetail'

export default connect(
  (state: IAppState, props): IAuditEventsDetailsState => ({
    event: getEvent(state, props),
    profile: state.profile.data
  }),
  { fetchAuditEvent }
)(memo(AuditEventsDetail))
